import { Card } from 'antd';
import './layout-card.less';

export const LayoutCard = ({ title, extra, children, onClick }) => (
  <Card className="layout-card" title={title} hoverable={true} onClick={onClick} extra={extra}>
    {children}
  </Card>
);
